/**
 * 詢問漏斗的事件酬載。
 *
 * 為什麼要有這個檔案，而不是各處 inline push：`submit_inquiry`（真的送出一筆需求）
 * 與「按了 LINE 詢問」是**兩件不同的事**。混在一起，一次點擊就會被算成一筆 lead，
 * 而那個數字會被拿去對外講轉換率。G14 的驗收把這句話寫成規則：
 * **LINE 點擊只能叫點擊。**
 *
 * 酬載一律不含姓名、Email、電話與訊息內文 —— dataLayer 的內容會離開我們的伺服器。
 * LINE 訊息本文確實帶著日期／人數／預算（那是要給場主看的），但**那些不進 dataLayer**。
 */

/** 點下去之後實際發生什麼事。手機直接開 LINE，桌面只能先給 QR（LINE 桌面版不支援預填）。 */
export type LineInquirySurface = 'line_app' | 'desktop_qr'

export interface LineInquiryClickEvent {
    event: 'line_inquiry_click'
    space_id: number
    surface: LineInquirySurface
}

export function lineInquiryClickEvent(spaceId: number, surface: LineInquirySurface): LineInquiryClickEvent {
    return {event: 'line_inquiry_click', space_id: spaceId, surface}
}

/** SSR 下沒有 window；少了這道守衛，元件在伺服器端跑的那一次會讓整頁 500。 */
export function pushDataLayerEvent(payload: Record<string, unknown>): void {
    if (typeof window === 'undefined') {
        return
    }
    const w = window as unknown as {dataLayer?: Record<string, unknown>[]}
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push(payload)
}
